import { render, staticRenderFns } from "./collectiondebitur.vue?vue&type=template&id=345e809d&"
import script from "./collectiondebitur.vue?vue&type=script&lang=js&"
export * from "./collectiondebitur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports